// extracted by mini-css-extract-plugin
export default {"link":"_1ae-QdBX","icon":"_26lbvf_L"};